/**
 * reduce to single array with parent and item index
 * @param {*} list - array with 3 arrays inside
 */
export const reduceToSingleArray = (list = []) => {
  if (!Array.isArray(list) || list.length === 0) return [];
  return list.reduce((acc, arr = [], parentIdx) => [...acc, ...arr.map((item, idx) => Object.assign({}, item, {
    parentIdx,
    idx
  }))], []);
};